<template>
  <div class="v-map" ref="map" :style="{ height: `${height}px` }">
    <v-map-popup
      v-if="google && map"
      :google="google"
      :map="map"
      :position="popup && popup.position"
    >
      <slot name="popup" v-if="popup" v-bind:popup="popup.data" />
    </v-map-popup>
  </div>
</template>

<script>
import GoogleMapsApiLoader from "google-maps-api-loader";
import MarkerClusterer from "@google/markerclustererplus";
const API_KEY = "AIzaSyBXzg6iUrL4pFqb79qK2ZtuK1AGusabY4E";
//"AIzaSyCxpYtB262U_Eyi94A5EIhuoa4NbQA4gwU";

export default {
  props: {
    markers: {
      type: Array,
      default: () => []
    },
    center: {
      type: Object,
      default: () => {
        return { lat: 56.3, lng: 11.7 };
      }
    },
    zoom: {
      type: Number,
      default: 7
    },
    zoomMobile: {
      type: Number,
      default: null
    },
    minZoom: {
      type: Number,
      default: null
    },
    maxZoom: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      mobile: false,
      map: null,
      popup: null,
      google: null,
      fixedMarkers: [],
      googleMarkers: [],
      clusterOptions: {
        maxZoom: 15,
        styles: [
          {
            width: 50,
            height: 50,
            className: "v-map__cluster app",
            url: require("./assets/cluster-icon.svg")
          }
        ]
      }
    };
  },
  created() {
    this.detectMobile();
    this.loadGoogleMaps();
  },
  methods: {
    detectMobile() {
      if (
        typeof window !== "undefined" &&
        !window.matchMedia("(min-width: 768px)").matches
      ) {
        this.mobile = true;
      }
    },
    loadGoogleMaps() {
      GoogleMapsApiLoader({
        apiKey: API_KEY
      }).then(googleApi => {
        this.google = googleApi;
        this.init();
      });
    },
    init() {
      this.map = new this.google.maps.Map(this.$refs.map, this.mapOptions());
      this.fixDuplicatePositions();
      this.initMarkers();
      this.initClusters();
    },
    fixDuplicatePositions() {
      this.markers.forEach(marker => {
        if (this.hasDuplicatePosition(marker)) {
          marker.position.lng += 0.0004;
        }
        this.fixedMarkers.push(marker);
      });
    },
    hasDuplicatePosition(marker) {
      const { lat, lng } = marker.position;
      return this.fixedMarkers.find(
        m => m.position.lat == lat && m.position.lng == lng
      );
    },
    initMarkers() {
      this.googleMarkers = this.fixedMarkers.map(marker => {
        const googleMarker = new this.google.maps.Marker({
          position: marker.position,
          map: this.map,
          icon: { url: this[`${marker.icon}Icon`] }
        });

        googleMarker.addListener("click", () => this.setPopup(marker));
        return googleMarker;
      });
    },
    initClusters() {
      new MarkerClusterer(this.map, this.googleMarkers, this.clusterOptions);
    },
    setPopup(marker) {
      this.popup = null;
      this.$nextTick(() => {
        this.popup = {
          position: marker.position,
          data: marker.popup
        };
      });
    },
    heartIcon(viewBox, color) {
      return `data:image/svg+xml;utf-8, \
        <svg width="24" height="21" viewBox="${viewBox}" xmlns="http://www.w3.org/2000/svg"> \
          <path d="M23.302 3.58a6.583 6.583 0 00-10.447-1.71L12 2.65l-.827-.752A6.523 6.523 0 005.485.092 6.473 6.473 0 00.7 3.579a6.4 6.4 0 001.21 7.47l9.374 9.657a1 1 0 001.434 0l9.361-9.64a6.415 6.415 0 001.223-7.486z" fill="%23${color}" fill-rule="evenodd"></path> \
        </svg>`;
    },
    mapOptions() {
      return {
        center: this.center,
        zoom: this.initialZoom(),
        minZoom: this.minZoom,
        maxZoom: this.maxZoom,
        streetViewControl: false,
        mapTypeControl: false
      };
    },
    initialZoom() {
      return this.mobile && this.zoomMobile ? this.zoomMobile : this.zoom;
    }
  },
  computed: {
    redHeartIcon() {
      return this.heartIcon("-5 -4 36 32", "E7131C");
    },
    grayHeartIcon() {
      return this.heartIcon("-10 -10 46 40", "939393");
    }
  }
};
</script>

<style lang="scss">
@import "../../sass/component.scss";

.app.v-map__cluster {
  display: flex;
  align-items: center;
  color: theme-color("white");
  font-weight: bold;
}
</style>
